import { Spinner } from "react-bootstrap";
import "./hr9.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import LeelaService from "../../services/leela.service";
import { ProviderContext } from "../../context/provider.context";
import GPTService from "../../services/gpt.service";
import tokenService from "../../services/token.service";

const HR9Component = () => {
    const { setProfileModel, setCreditModel }: any = useContext(ProviderContext)
    const location = useLocation();
    const [path, setPath] = useState<string | null>(null);
    const [companyUuid, setCompanyUuid] = useState<string | null>(null);
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        setPath(queryParams.get('path'));
        setCompanyUuid(queryParams.get('companyUuid'));
        setAccessToken(queryParams.get('accessToken'));
        tokenService.setHR9AccessToken(queryParams.get('accessToken'));
        tokenService.setHR9CompanyUUID(queryParams.get('companyUuid'));
    }, [location.search]);
    useEffect(() => {
        if (companyUuid && accessToken) {
            console.log(companyUuid, accessToken);
            getActiveSubscription();
        }
    }, [companyUuid, accessToken]);
    const getActiveSubscription = () => {
        const queryParams = new URLSearchParams(location.search);
        LeelaService().getActiveSubscription(accessToken, companyUuid).then((res) => {


            LeelaService().getProfile(accessToken, companyUuid).then((profileResult) => {
                if (profileResult) {

                    setProfileModel(profileResult);

                    GPTService.getCredit().then((creditModel) => {

                        console.log(creditModel);
                        setCreditModel(creditModel.data);

                        // Navigate if the path includes "xxx"
                        if (path && path.includes("create-job")) {
                            // Add the "isHR9=true" parameter to the existing query parameters
                            queryParams.set('isHR9', 'true');

                            // Navigate to "/xxx" with the updated query parameters
                            navigate({
                                pathname: '/hr9/jd-generator',
                                search: queryParams.toString()
                            });
                        } else if (path && path.includes("ats/job/")) {
                            // Add the "isHR9=true" parameter to the existing query parameters
                            queryParams.set('isHR9', 'true');
                            const pathSegments = path.split('ats/job/');
                            const idIndex = pathSegments[1];
                            console.log(pathSegments,idIndex);
                            if (idIndex.length > 0) {
                                queryParams.set('job_id', idIndex);
                                // Navigate to "/xxx" with the updated query parameters
                                navigate({
                                    pathname: '/hr9/jd-checker',
                                    search: queryParams.toString()
                                });
                            }

                        }
                        else {
                            queryParams.set('isHR9', 'true');
                            navigate({
                                pathname: '/hr9/menu',
                                search: queryParams.toString()
                            });

                        }
                    })

                }


            })

        }).catch((error) => {
            // Handle errors here
            console.error("Error fetching active subscription:", error);
        });
    }

    return (

        <>
            <div className="hr9-main">
                <div className="hr9-control">
                    <Spinner className="hr9-spinner"></Spinner>
                    <span className="hr9-text">กำลังตรวจสอบ</span>
                </div>
            </div>

        </>
    )
}


export default HR9Component;